
export default {
  inject: ['wording'],
  props: {
    benefits: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      wording: this.wording,
    }
  },
}
